import React from 'react';

import {
  Icon,
  Button,
  Tooltip,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import * as S from './styled';

type Props = {
  query: string;
  tooltipText: string;
  onSearch: { (): void };
  onUpload: { (): void };
  onSetQuery: { (query: string | null): void };
};

const ManageVideoUpload = ({
  query,
  tooltipText,
  onSearch,
  onUpload,
  onSetQuery,
}: Props) => {
  const searchBar = (
    <S.Search
      onKeyDown={(e) => {
        if (e.keyCode === 13 && query) {
          onSearch();
        }
      }}
    >
      <S.Input
        autoFocus
        placeholder="Search for a video"
        value={query}
        onChange={(e) => onSetQuery(e.target.value)}
      />
      <S.SearchButton
        active={!!query}
        onClick={onSearch}
      >
        <Icon
          size="15px"
          type="fas fa-search"
        />
      </S.SearchButton>
    </S.Search>
  );

  return (
    <Flex
      column
      shrink="0"
      width="100%"
      spacing={5}
    >
      <Flex
        width="100%"
        spacing={30}
      >
        <Flex
          width="100%"
          column
          spacing={5}
          align="center"
        >
          {tooltipText ? (
            <Tooltip
              body={tooltipText}
              width="300px"
            >
              {searchBar}
            </Tooltip>
          ) : searchBar}
        </Flex>
        <Button
          icon="fas fa-cloud-upload-alt"
          appearance="success"
          onClick={onUpload}
        >
          Upload Video
        </Button>
      </Flex>
    </Flex>
  );
};

export default ManageVideoUpload;
